



const Serverurl= ["https://app.mmcoachingmysuru.com/appfiles/"]
//const Serverurl= ["http://localhost/xampp/apoorva/mmcoaching/mmc/"]

//const Serverurl= ["http://localhost:8080/xampp/mmc/"]


export default Serverurl;






